module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'olst-virtualform': true, 'olst-virtualform-min': (_vm.isAbtested || _vm.isVrAbtested), 'olst-mobile-device': _vm.isMobile
    }
  }, [_c('div', [(!_vm.isAbtested && !_vm.isVrAbtested) ? _c('ol', _vm._l((_vm.filterRecipeFields), function(field, fieldKey, fieldIndice) {
    return (_vm.fieldIsNotHidden(fieldKey)) ? _c('li', {
      class: _vm.abTestHiddenFields(fieldKey) ? 'olst-hidden' : '',
      attrs: {
        "id": fieldKey
      }
    }, [_c('div', {
      staticClass: "olst-base-field"
    }, [_c(_vm.renderingUnitToLoad(field, fieldKey), {
      tag: "component",
      attrs: {
        "mint": _vm.mint,
        "version": _vm.version,
        "productReference": _vm.productReference,
        "fieldRef": fieldKey,
        "field": field,
        "cc_value": _vm.fieldValueInCC(fieldKey),
        "uom": _vm.uom
      },
      on: {
        "field-changed": _vm.fieldHasChanged
      }
    })], 1)]) : _vm._e()
  })) : _vm._e(), (_vm.isAbtested) ? _c('div', _vm._l((_vm.filterRecipeGroupedFields()), function(filterRecipeFieldsItems, index) {
    return _c('div', [_c('div', {
      staticClass: "accordion",
      class: (filterRecipeFieldsItems.accordion.open === true) ? 'open' : 'close'
    }, [_c('label', {
      staticClass: "grouped-fields-title",
      attrs: {
        "for": filterRecipeFieldsItems.items[0].fieldKey
      },
      domProps: {
        "innerHTML": _vm._s((index + 1) + '. ' + filterRecipeFieldsItems.label)
      },
      on: {
        "click": function($event) {
          _vm.accordionToggle(filterRecipeFieldsItems.key)
        }
      }
    }), (filterRecipeFieldsItems.key === 'COLORIS' && filterRecipeFieldsItems.accordion.open && _vm.colorPickerHasError()) ? _c('label', {
      staticClass: "color-picker-summary-value-error fp-error--excl",
      domProps: {
        "innerHTML": _vm._s(_vm.colorPickerErrorSummary)
      }
    }) : _vm._e(), _c('div', {
      staticClass: "accordion-switch",
      class: (filterRecipeFieldsItems.accordion.open === true) ? 'open' : 'close',
      domProps: {
        "textContent": _vm._s((filterRecipeFieldsItems.accordion.open === true) ? 'Fermer' : 'Modifier')
      },
      on: {
        "click": function($event) {
          _vm.accordionToggle(filterRecipeFieldsItems.key)
        }
      }
    }), (filterRecipeFieldsItems.key === 'COLORIS') ? _c('div', {
      staticClass: "olst-base-field-closed color-picker-summary-color-container",
      on: {
        "click": function($event) {
          _vm.accordionToggle(filterRecipeFieldsItems.key)
        }
      }
    }, [(_vm.colorPictureStyleBackground(_vm.getRelatedColorPicture('CH-143_coloris-1', _vm.cc.config_1.prefilled_values['CH-143_coloris-1']))) ? _c('div', {
      staticClass: "color-picker-summary-color"
    }, [(_vm.colorPictureStyleBackground(_vm.getRelatedColorPicture('CH-143_coloris-1', _vm.cc.config_1.prefilled_values['CH-143_coloris-1']))) ? _c('div', {
      staticClass: "round-color-img",
      style: ({
        'background': _vm.colorPictureStyleBackground(_vm.getRelatedColorPicture('CH-143_coloris-1', _vm.cc.config_1.prefilled_values['CH-143_coloris-1']))
      })
    }) : _vm._e(), (_vm.colorPictureStyleBackground(_vm.getRelatedColorPicture('CH-144_coloris-2', _vm.cc.config_1.prefilled_values['CH-144_coloris-2']))) ? _c('div', {
      staticClass: "round-color-img",
      style: ({
        'background': _vm.colorPictureStyleBackground(_vm.getRelatedColorPicture('CH-144_coloris-2', _vm.cc.config_1.prefilled_values['CH-144_coloris-2']))
      })
    }) : _vm._e(), (_vm.colorPictureStyleBackground(_vm.getRelatedColorPicture('CH-145_coloris-3', _vm.cc.config_1.prefilled_values['CH-145_coloris-3']))) ? _c('div', {
      staticClass: "round-color-img",
      style: ({
        'background': _vm.colorPictureStyleBackground(_vm.getRelatedColorPicture('CH-145_coloris-3', _vm.cc.config_1.prefilled_values['CH-145_coloris-3']))
      })
    }) : _vm._e()]) : _vm._e(), _c('div', {
      staticClass: "color-picker-summary-text"
    }, [_c('div', {
      staticClass: "color-picker-summary"
    }, [(_vm.humanized['Type de toile'] || _vm.humanized['Gamme Client']) ? _c('label', {
      staticClass: "color-picker-summary-title",
      domProps: {
        "textContent": _vm._s('Toile : ')
      }
    }) : _vm._e(), _c('label', {
      staticClass: "color-picker-summary-value",
      domProps: {
        "textContent": _vm._s(_vm.humanized['Type de toile'] || _vm.humanized['Gamme Client'])
      }
    })]), _c('div', {
      staticClass: "color-picker-summary"
    }, [_c('label', {
      staticClass: "color-picker-summary-title",
      domProps: {
        "textContent": _vm._s('Coloris : ')
      }
    }), _vm._l((_vm.groupedFieldSummary(filterRecipeFieldsItems.key)), function(field) {
      return _c('label', {
        staticClass: "color-picker-summary-value",
        domProps: {
          "textContent": _vm._s(field.value)
        }
      })
    }), (_vm.colorPickerHasError()) ? _c('label', {
      staticClass: "color-picker-summary-value-error fp-error--excl",
      domProps: {
        "innerHTML": _vm._s(_vm.colorPickerErrorSummary)
      }
    }) : _vm._e()], 2)])]) : _vm._e(), (filterRecipeFieldsItems.key !== 'COLORIS') ? _c('div', {
      staticClass: "olst-base-field-closed",
      on: {
        "click": function($event) {
          _vm.accordionToggle(filterRecipeFieldsItems.key)
        }
      }
    }, _vm._l((_vm.groupedFieldSummary(filterRecipeFieldsItems.key)), function(field) {
      return _c('div', {
        staticClass: "olst-base-field-closed-summary-item"
      }, [_c('label', {
        staticClass: "olst-base-field-closed-summary-item-label",
        domProps: {
          "textContent": _vm._s(field.label)
        }
      }), _c('label', {
        staticClass: "olst-base-field-closed-summary-item-value",
        domProps: {
          "textContent": _vm._s(field.value)
        }
      }), (field.error) ? _c('label', {
        staticClass: "olst-base-field-closed-summary-item-error fp-error--excl",
        domProps: {
          "textContent": _vm._s(field.error)
        }
      }) : _vm._e()])
    })) : _vm._e(), (filterRecipeFieldsItems.key === 'DIMENSIONSDUSTORE') ? _c('div', {
      staticClass: "olst-base-multi-field"
    }, [_c('dimensions-field-widget', {
      attrs: {
        "cc": _vm.cc,
        "mint": _vm.mint,
        "version": _vm.version,
        "productReference": _vm.productReference,
        "cc_value": _vm.fieldValueInCC(_vm.fieldKey),
        "fieldHasChanged": _vm.fieldHasChanged,
        "uom": _vm.uom,
        "widthField": _vm.getWidthField,
        "heightField": _vm.getHeightField,
        "widthFieldRef": _vm.getDimInfo(_vm.productReference).widthFieldRef,
        "heightFieldRef": _vm.getDimInfo(_vm.productReference).heightFieldRef,
        "widthFieldLabel": _vm.getDimInfo(_vm.productReference).widthLabel,
        "widthFieldSubtitle": _vm.getDimInfo(_vm.productReference).widthSubtitle,
        "heightFieldLabel": _vm.getDimInfo(_vm.productReference).heightLabel,
        "heightFieldSubtitle": _vm.getDimInfo(_vm.productReference).heightSubtitle,
        "docLink": _vm.getDimInfo(_vm.productReference).docLink
      },
      on: {
        "field-changed": _vm.fieldHasChanged
      }
    })], 1) : _vm._e(), (filterRecipeFieldsItems.key === 'MECANISME') ? _c('div', {
      staticClass: "olst-base-multi-field"
    }, [_c('div', {
      staticClass: "olst-base-field"
    }, [_c('rail-field-widget', {
      attrs: {
        "cc": _vm.cc,
        "railTypeField": _vm.getRailTypeField,
        "railColorField": _vm.getRailColorField
      },
      on: {
        "change-rail-color-type": _vm.caliWidgetRailChanged
      }
    })], 1)]) : _vm._e(), (filterRecipeFieldsItems.key === 'COLORIS') ? _c('div', {
      staticClass: "olst-base-multi-field"
    }, [_c('color-picker-field-widget', {
      attrs: {
        "cc": _vm.cc,
        "mint": _vm.mint,
        "version": _vm.version,
        "productReference": _vm.productReference,
        "cc_value": _vm.fieldValueInCC(_vm.fieldKey),
        "uom": _vm.uom,
        "filter": _vm.getFilterField,
        "colorisA": _vm.getColorisAField,
        "colorisB": _vm.getColorisBField,
        "colorisC": _vm.getColorisCField,
        "totalColorVariation": _vm.getTotalColorVariationField
      },
      on: {
        "field-changed": _vm.fieldHasChanged
      }
    })], 1) : _vm._e(), _vm._l((filterRecipeFieldsItems.items), function(field) {
      return (_vm.fieldIsNotHidden(field.fieldKey) && filterRecipeFieldsItems.key !== 'MECANISME' && filterRecipeFieldsItems.key !== 'DIMENSIONSDUSTORE' && filterRecipeFieldsItems.key !== 'COLORIS') ? _c('div', [_c('div', {
        staticClass: "olst-base-field"
      }, [_c(_vm.renderingUnitToLoad(field, field.fieldKey), {
        tag: "component",
        attrs: {
          "mint": _vm.mint,
          "version": _vm.version,
          "productReference": _vm.productReference,
          "fieldRef": field.fieldKey,
          "field": field,
          "cc_value": _vm.fieldValueInCC(field.fieldKey),
          "uom": _vm.uom
        },
        on: {
          "field-changed": _vm.fieldHasChanged
        }
      })], 1)]) : _vm._e()
    })], 2), (_vm.filterRecipeGroupedFields().length !== index + 1) ? _c('div', {
      staticClass: "bloc-separator"
    }) : _vm._e()])
  })) : _vm._e(), (_vm.isVrAbtested) ? _c('div', [_vm._l((_vm.VoletRoulantFilterRecipeGroupedFields()), function(filterRecipeFieldsItems, index) {
    return _c('div', {
      class: {
        'olst-hidden': _vm.isHiddenGroup(filterRecipeFieldsItems.key)
      },
      attrs: {
        "id": filterRecipeFieldsItems.key
      }
    }, [_c('div', {
      staticClass: "accordion",
      class: {
        'open': (filterRecipeFieldsItems.accordion.open === true), 'close': (filterRecipeFieldsItems.accordion.open !== true), 'olst-hidden': (filterRecipeFieldsItems.hidden === true)
      }
    }, [_c('label', {
      staticClass: "grouped-fields-title",
      attrs: {
        "for": filterRecipeFieldsItems.items[0].fieldKey
      },
      domProps: {
        "innerHTML": _vm._s((index + 1) + '. ' + filterRecipeFieldsItems.label)
      },
      on: {
        "click": function($event) {
          _vm.accordionVrToggle(filterRecipeFieldsItems.key)
        }
      }
    }), (filterRecipeFieldsItems.key === 'COLORIS' && filterRecipeFieldsItems.accordion.open && _vm.vrColorPickerHasError()) ? _c('label', {
      staticClass: "color-picker-summary-value-error fp-error--excl",
      domProps: {
        "innerHTML": _vm._s(_vm.vrColorPickerErrorSummary)
      }
    }) : _vm._e(), _c('div', {
      staticClass: "accordion-switch",
      class: (filterRecipeFieldsItems.accordion.open === true) ? 'open' : 'close',
      domProps: {
        "textContent": _vm._s((filterRecipeFieldsItems.accordion.open === true) ? 'Fermer' : 'Modifier')
      },
      on: {
        "click": function($event) {
          _vm.accordionVrToggle(filterRecipeFieldsItems.key)
        }
      }
    }), (filterRecipeFieldsItems.key === 'COLORIS') ? _c('div', {
      staticClass: "olst-base-field-closed color-picker-summary-color-container",
      on: {
        "click": function($event) {
          _vm.accordionVrToggle(filterRecipeFieldsItems.key)
        }
      }
    }, [(_vm.colorPictureStyleBackground(_vm.getRelatedColorPicture('CH-461_coloris', _vm.cc.config_1.prefilled_values['CH-461_coloris']))) ? _c('div', {
      staticClass: "color-picker-summary-color"
    }, [(_vm.colorPictureStyleBackground(_vm.getRelatedColorPicture('CH-461_coloris', _vm.cc.config_1.prefilled_values['CH-461_coloris']))) ? _c('div', {
      staticClass: "round-color-img",
      style: ({
        'background': _vm.colorPictureStyleBackground(_vm.getRelatedColorPicture('CH-461_coloris', _vm.cc.config_1.prefilled_values['CH-461_coloris']))
      })
    }) : _vm._e()]) : _vm._e(), _c('div', {
      staticClass: "color-picker-summary-text"
    }, [_c('div', {
      staticClass: "color-picker-summary"
    }, [_c('label', {
      staticClass: "color-picker-summary-title",
      domProps: {
        "textContent": _vm._s('Matière : ')
      }
    }), _c('label', {
      staticClass: "color-picker-summary-value",
      domProps: {
        "textContent": _vm._s(_vm.humanized['Matière'])
      }
    })]), _c('div', {
      staticClass: "color-picker-summary"
    }, [_c('label', {
      staticClass: "color-picker-summary-title",
      domProps: {
        "textContent": _vm._s('Coloris : ')
      }
    }), _c('label', {
      staticClass: "color-picker-summary-value",
      domProps: {
        "textContent": _vm._s(_vm.humanized['Coloris'])
      }
    }), (_vm.vrColorPickerHasError()) ? _c('label', {
      staticClass: "color-picker-summary-value-error fp-error--excl",
      domProps: {
        "innerHTML": _vm._s(_vm.vrColorPickerErrorSummary)
      }
    }) : _vm._e()])])]) : _vm._e(), (filterRecipeFieldsItems.key !== 'COLORIS') ? _c('div', {
      staticClass: "olst-base-field-closed",
      on: {
        "click": function($event) {
          _vm.accordionVrToggle(filterRecipeFieldsItems.key)
        }
      }
    }, _vm._l((_vm.groupedFieldSummary(filterRecipeFieldsItems.key, _vm.productReference)), function(field) {
      return _c('div', {
        staticClass: "olst-base-field-closed-summary-item"
      }, [(_vm.fieldIsVisible(field.key)) ? _c('label', {
        staticClass: "olst-base-field-closed-summary-item-label",
        domProps: {
          "textContent": _vm._s(field.label)
        }
      }) : _vm._e(), (_vm.fieldIsVisible(field.key)) ? _c('label', {
        staticClass: "olst-base-field-closed-summary-item-value",
        domProps: {
          "textContent": _vm._s(field.value)
        }
      }) : _vm._e(), (field.error) ? _c('label', {
        staticClass: "olst-base-field-closed-summary-item-error fp-error--excl",
        domProps: {
          "textContent": _vm._s(field.error)
        }
      }) : _vm._e()])
    })) : _vm._e(), (filterRecipeFieldsItems.key === 'DIMENSIONSDUVOLET') ? _c('div', {
      staticClass: "olst-base-multi-field"
    }, [_c('dimensions-field-widget', {
      attrs: {
        "cc": _vm.cc,
        "mint": _vm.mint,
        "version": _vm.version,
        "productReference": _vm.productReference,
        "cc_value": _vm.fieldValueInCC(_vm.fieldKey),
        "fieldHasChanged": _vm.fieldHasChanged,
        "uom": _vm.uom,
        "widthField": _vm.getVrWidthField,
        "heightField": _vm.getVrHeightField,
        "widthFieldRef": _vm.getDimInfo(_vm.productReference).widthFieldRef,
        "heightFieldRef": _vm.getDimInfo(_vm.productReference).heightFieldRef,
        "widthFieldLabel": _vm.getDimInfo(_vm.productReference).widthLabel,
        "widthFieldSubtitle": _vm.getDimInfo(_vm.productReference).widthSubtitle,
        "heightFieldLabel": _vm.getDimInfo(_vm.productReference).heightLabel,
        "heightFieldSubtitle": _vm.getDimInfo(_vm.productReference).heightSubtitle,
        "docLink": _vm.getDimInfo(_vm.productReference).docLink
      },
      on: {
        "field-changed": _vm.fieldHasChanged
      }
    })], 1) : _vm._e(), (filterRecipeFieldsItems.key === 'COLORIS') ? _c('div', {
      staticClass: "olst-base-multi-field"
    }, [_c('vr-color-picker-field-widget', {
      attrs: {
        "cc": _vm.cc,
        "mint": _vm.mint,
        "version": _vm.version,
        "productReference": _vm.productReference,
        "cc_value": _vm.fieldValueInCC(_vm.fieldKey),
        "uom": _vm.uom,
        "colorisA": _vm.getVrColorisAField,
        "validation": _vm.validation
      },
      on: {
        "field-changed": _vm.fieldHasChanged
      }
    })], 1) : _vm._e(), _vm._l((filterRecipeFieldsItems.items), function(field) {
      return (_vm.fieldIsNotHidden(field.fieldKey) && filterRecipeFieldsItems.key !== 'DIMENSIONSDUVOLET' && filterRecipeFieldsItems.key !== 'COLORIS') ? _c('div', [_c('div', {
        staticClass: "olst-base-field",
        class: field.fieldKey
      }, [_c(_vm.renderingUnitToLoad(field, field.fieldKey), {
        tag: "component",
        attrs: {
          "mint": _vm.mint,
          "version": _vm.version,
          "productReference": _vm.productReference,
          "validation": _vm.validation,
          "cc": _vm.cc,
          "fieldRef": field.fieldKey,
          "field": field,
          "cc_value": _vm.fieldValueInCC(field.fieldKey),
          "uom": _vm.uom
        },
        on: {
          "field-changed": _vm.fieldHasChanged
        }
      })], 1)]) : _vm._e()
    })], 2), (_vm.VoletRoulantFilterRecipeGroupedFields().length !== index + 1 && _vm.VoletRoulantFilterRecipeGroupedFields().length !== index + 2) ? _c('div', {
      staticClass: "bloc-separator"
    }) : _vm._e()])
  }), _vm._l((_vm.validation.info['CH-467_anti-vol']), function(message, key) {
    return _c('div', {
      staticClass: "olst-field-validation-picture-field-alt"
    }, [_c('div', {
      staticClass: "olst-field-infos olst-field-info",
      domProps: {
        "textContent": _vm._s(message)
      }
    })])
  })], 2) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-42a10e35!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@oliverstore/core-rendering-engine/src/views/rendering_block/VirtualForm.vue
// module id = 348
// module chunks = 1